// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"379ec5e3","219":"379ec5e3","351":"379ec5e3","711":"379ec5e3"}[chunkId] + ".chunk.css";
};